export enum WagerChangeActionName {
    'add' = 'add',
    'remove' = 'remove'
}